import bootstrap from './bootstrap';

export default () => bootstrap().then(({ client }) => client);
